/* unplugin-vue-components disabled */import { render } from "./HomeNew.vue?vue&type=template&id=b9d245b4&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"

import "./HomeNew.vue?vue&type=style&index=0&id=b9d245b4&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-digital-read\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d245b4"]])

export default __exports__